module.exports = __webpack_public_path__ + "static/media/brighteningpeelbooster.ddef6dbf.png";